import { Routes } from '@angular/router';
import { EnvironmentListComponent } from './pages/environment-list/environment-list.component';

//import { EnvionmentCreateFormComponent } from './pages/environment-create-form.component';
//import { EnvionmentDetailsComponent } from './pages/environment-details.component';
import { UserConsumptionComponent } from './pages/user-consumption/user-consumption.component';
import { PageNotFoundComponent } from './components/utility-components/page-not-found/page-not-found.component';
import { ModelListComponent } from './pages/model-list/model-list.component';
import { EnvironmentDetailsComponent } from './pages/environment-details/environment-details.component';


import { ModelCardComponent } from './pages/model-card/model-card.component';
import { CreateEnvironmentFormComponent } from './pages/create-environment-form/create-environment-form.component';
import { HomeComponent } from './pages/home/home.component';
import { DatasetListComponent } from './pages/dataset-list/dataset-list.component';
import { DatasetCardComponent } from './pages/dataset-card/dataset-card.component';
import { IframePageComponent } from './pages/iframe-page/iframe-page.component';


export const routes: Routes = [
   /*  {
      path: '',
      component: HomeComponent,
      title: 'Welcome to CAIES'
    },
    {
      path: 'list',
      component: EnvironmentListComponent,
      title: 'Environment List'
    },
  {
        path: 'consumption',
        component: UserConsumptionComponent,
        title: 'User Consumption'
    },
       {
        path: 'model',
        component: ModelListComponent,
        title: 'Model'
    },
           {
        path: 'dataset',
        component: DatasetListComponent,
        title: 'Dataset'
    },
     {
        path: 'newenvironment',
        component: CreateEnvironmentFormComponent,
        title: 'Create a Environment'
    },
    {
        path: 'details/:id',
        component: EnvironmentDetailsComponent,
        title: 'Environment Details'
      }, 
{
  path: 'modeldetails/:slug',
  loadComponent: () =>
    import('./pages/model-card/model-card.component')
      .then(m => m.ModelCardComponent),
},
{
  path: 'datasetdetails/:slug',
  loadComponent: () =>
    import('./pages/dataset-card/dataset-card.component')
      .then(m => m.DatasetCardComponent)
}, */
{
  path: '',
  component: IframePageComponent,
  title: 'AIFS predictions generator'
},

    { path: '**', component: PageNotFoundComponent },
      
];
